import { useState } from "react"

import { Checkbox, Select, spacing, Text } from "@minuthq/meatball-ui-react"

import { DatePickerDropdown } from "src/ui/DateRangePicker/DatePickerDropdown"
import { DateRangeDropdown } from "src/ui/DateRangePicker/DateRangeDropdown"
import {
  DateRangePicker,
  TDateRange,
} from "src/ui/DateRangePicker/DateRangePicker"
import { MCard } from "src/ui/MCard/MCard"
import { MDateTimePicker } from "src/ui/MDateTimePicker/MDateTimePicker"
import { MTimePickerInput } from "src/ui/MTimePickerInput/MTimePickerInput"
import { TMTimePickerInputValue } from "src/ui/MTimePickerInput/timePickerUtils"

export function DateTimeDemo() {
  const [dateTimePickerValue, setDateTimePickerValue] = useState<Date | null>(
    null
  )
  const [startDate, setStartDate] = useState<Date | null>(null)
  const [endDate, setEndDate] = useState<Date | null>(null)
  const [clockType, setClockType] = useState<"12" | "24">("24")
  const [required, setRequired] = useState(false)
  const [timePickerValue, setTimePickerValue] =
    useState<TMTimePickerInputValue | null>(null)

  return (
    <div style={{ display: "grid", gap: spacing.XL }}>
      <MCard border={true} boxShadow={false}>
        <Text variant="subtitleS">Configuration</Text>
        <div
          style={{
            display: "flex",
            gap: spacing.S,
          }}
        >
          <Checkbox
            checked={required}
            onCheck={(checked) => setRequired(checked)}
            label="Required"
          />

          <div>
            <Select
              value={clockType}
              label="Clock type"
              options={[
                { label: "12", value: "12" },
                { label: "24", value: "24" },
              ]}
              onChange={(selectedValue) =>
                setClockType(selectedValue as "12" | "24")
              }
            />
          </div>
        </div>
      </MCard>

      <div>
        <Text variant="heading3">DatePickerDropdown</Text>
        <DatePickerDropdown
          date={startDate}
          onChange={setStartDate}
          required={required}
        />
        <ValueText>date: {startDate ? startDate.toString() : "null"}</ValueText>
      </div>

      <div>
        <Text variant="heading3">DateRangeDropdown</Text>
        <DateRangeDropdown
          dateRange={{ startDate, endDate }}
          setDateRange={(dr: TDateRange): void => {
            setStartDate(dr.startDate)
            setEndDate(dr.endDate)
          }}
          required={required}
        />
        <ValueText>
          startDate: {startDate ? startDate.toString() : "null"}
        </ValueText>
        <ValueText>endDate: {endDate ? endDate.toString() : "null"}</ValueText>
      </div>

      <div>
        <Text variant="heading3">DateRangePicker</Text>
        <DateRangePicker
          startDate={startDate}
          endDate={endDate}
          onDateRangeChange={(dr: TDateRange) => {
            setStartDate(dr.startDate)
            setEndDate(dr.endDate)
          }}
          dateRangeProps={{}}
        />
        <ValueText>
          startDate: {startDate ? startDate.toString() : "null"}
        </ValueText>
        <ValueText>endDate: {endDate ? endDate.toString() : "null"}</ValueText>
      </div>

      <div>
        <Text variant="heading3">TimePickerInput</Text>
        <MTimePickerInput
          initialValue={timePickerValue}
          interval={15}
          clockType={clockType}
          onChange={(value) => {
            setTimePickerValue(value)
          }}
        />
        <ValueText>
          time: {timePickerValue ? timePickerValue : "null"}
        </ValueText>
      </div>

      <div>
        <Text variant="heading3">DateTimePicker</Text>
        <MDateTimePicker
          initialDate={dateTimePickerValue}
          onChange={(date) => {
            setDateTimePickerValue(date)
          }}
          timePickerInputProps={{
            clockType,
          }}
        />
        <ValueText>
          date: {dateTimePickerValue ? dateTimePickerValue.toString() : "null"}
        </ValueText>
      </div>
    </div>
  )
}

function ValueText({ children }: { children: React.ReactNode }) {
  return (
    <Text variant="bodyS" color="secondary">
      {children}
    </Text>
  )
}
